export default "__VITE_ASSET__BoO2Yoo9__"